"use client";

import { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import { ThemeToggle as SpeakThemeToggle, ThemeSelector as SpeakThemeSelector } from "@speakai/ui/theme-toggle";
export type Theme = "light" | "dark" | "system";

export function normalizeTheme(theme?: string): Theme {
  if (theme === "light" || theme === "dark" || theme === "system") {
    return theme;
  }
  return "system";
}

export function ThemeToggle() {
  const { setTheme, theme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <SpeakThemeToggle
        theme="system"
        className="opacity-0 pointer-events-none"
        aria-hidden
      />
    );
  }

  return (
    <SpeakThemeToggle
      theme={normalizeTheme(theme)}
      onChange={(nextTheme) => setTheme(nextTheme)}
      title={`Current theme: ${theme}. Click to switch.`}
      className="text-foreground"
    />
  );
}

export function ThemeSelector() {
  const { setTheme, theme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <SpeakThemeSelector
      theme={normalizeTheme(theme)}
      onChange={(nextTheme) => setTheme(nextTheme)}
      className="w-full min-w-0 [&>button]:flex-1 [&>button]:h-9 pointer-coarse:[&>button]:h-11 [&>button>span]:inline"
    />
  );
}
